import { useState } from "react";
import api from "../lib/api";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function AffiliateSignup({ program = "marketing" }) {
  const [form, setForm] = useState({
    full_name: "", email: "", phone: "", website: "", audience_size: 0, channels: "", notes: "", program,
  });
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/affiliates/signup", form);
      setSubmitted(true);
      toast.success("Application received.");
    } catch { toast.error("Submission failed."); }
  };

  const isLink = program === "link_sharing";
  const title = isLink ? "Link Sharing Program" : "Marketing Affiliates";
  const tier = isLink ? "Tier 03 · Publishers" : "Tier 02 · Marketing";
  const desc = isLink
    ? "For directories, blogs, and classified networks. Share branded links and earn per qualified click + per booking."
    : "For influencers, brokers, and channel partners. Recurring commission on every booking you refer.";

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid={`affiliate-${program}`}>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2">
          <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// {tier}</div>
          <h1 className="display-black text-4xl lg:text-5xl uppercase text-[#064E3B] mt-3 tracking-tighter">{title}</h1>
          <p className="text-gray-700 mt-4">{desc}</p>
          <ul className="mt-6 space-y-3 text-sm text-gray-800">
            <li className="flex gap-3"><span className="text-[#D97706] font-bold">▸</span> Branded tracking links</li>
            <li className="flex gap-3"><span className="text-[#D97706] font-bold">▸</span> Monthly payouts (USD/CAD)</li>
            <li className="flex gap-3"><span className="text-[#D97706] font-bold">▸</span> Creative kits + co-branded landing pages</li>
            <li className="flex gap-3"><span className="text-[#D97706] font-bold">▸</span> Direct line to network managers</li>
          </ul>
        </div>
        <div className="lg:col-span-3">
          {submitted ? (
            <div className="border border-[#064E3B] p-10 bg-gray-50" data-testid="affiliate-success">
              <div className="display-black text-2xl uppercase text-[#064E3B]">★ Application received</div>
              <p className="text-gray-700 mt-3">We'll reach out within 3 business days with your tracking links and creative assets.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-5 border border-gray-300 p-8" data-testid="affiliate-form">
              <input className="input-federal" required placeholder="Full name" value={form.full_name} onChange={e => setForm({...form, full_name: e.target.value})} data-testid="aff-name" />
              <input className="input-federal" required type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} data-testid="aff-email" />
              <input className="input-federal" placeholder="Phone (optional)" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} data-testid="aff-phone" />
              <input className="input-federal" placeholder="Website / Profile URL" value={form.website} onChange={e => setForm({...form, website: e.target.value})} data-testid="aff-website" />
              <input className="input-federal" type="number" min={0} placeholder="Audience size" value={form.audience_size} onChange={e => setForm({...form, audience_size: parseInt(e.target.value)||0})} data-testid="aff-audience" />
              <input className="input-federal" required placeholder="Channels (YouTube, Newsletter, Directory…)" value={form.channels} onChange={e => setForm({...form, channels: e.target.value})} data-testid="aff-channels" />
              <textarea className="input-federal md:col-span-2" rows={4} placeholder="Tell us about your audience" value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} data-testid="aff-notes" />
              <button type="submit" className="btn-federal md:col-span-2 justify-center" data-testid="aff-submit">Submit Application <ArrowRight className="w-4 h-4" /></button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
